import React from 'react';
import Axios from 'axios';
import { API_HOST, axiosInstance, axiosRequest, axiosRequestWithAuth } from './../../constants/server.constant';
import ReactToolTip from 'react-tooltip';
import Validate from './../common/validate';
import $ from 'jquery';
import { SessionService } from './../../services/session.service';

class Partnerindex extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hidePwd: true,
            trackId: SessionService.getCookie("partner_username"),
            isPwdShown: false,
            currentMonth: new Date().getMonth() + 1,
            currentYear: new Date().getFullYear(),
            resetMonth: new Date().getMonth() + 1,
            resetYear: new Date().getFullYear(),
            yearData: [],
            userList: [],
            isPasswordEnable: false,
            currentPswd: "",
            newPswd: "",
            confirmPswd: "",
            currentPswdEmpty: false,
            newPswdEmpty: false,
            confirmPswdError: false,
            currentPswdError: false,
            newPswdError: false,
            newPswdRegex: false,
            showLoader: true,
            getcurpswd: false,
            getnewpswd: false,
            totalUsers: 0,
            paidUsers: 0,
            freeUsers: 0,
            promoUrl: "",
            nameToggle: true,
            emailToggle: false,
            dateToggle: false,
            planToggle: false,
            statusToggle: false,
            isAction: false,
            message: "",
            msgType: "",
            isPartnerAvailable: false
        };

        this.loadCss = this.loadCss.bind(this);
        this.currentPasswordFocus = React.createRef();
        this.newPasswordFocus = React.createRef();
        this.confirmPasswordFocus = React.createRef();
        this.enableChangePassword = this.enableChangePassword.bind(this);
        this.getReport = this.getReport.bind(this);
        this.getCompleteReport = this.getCompleteReport.bind(this);
        this.handleInputs = this.handleInputs.bind(this);
        this.logout = this.logout.bind(this);
        this.changePassword = this.changePassword.bind(this);
        this.inputFocus = this.inputFocus.bind(this);

        this.handleOTPKeyUp = this.keyUpHandler.bind(this, 'password');
    }
    keyUpHandler(refName, e) {
        if(refName == "password") {
            if(e.keyCode == 13) {
                this.changePassword();
            }
        }
    }
    inputFocus = (param) => {
        if(param === "newPswd") {
            if(this.state.currentPswd.trim().length > 0) {
                this.setState({
                    currentPswdEmpty: false
                });
            }
            else {
                this.setState({
                    currentPswdEmpty: true
                });
            }
        }
        if(param === "confirmPswd") {
            if(this.state.currentPswd.trim().length > 0) {
                this.setState({
                    currentPswdEmpty: false
                });
            }
            if(this.state.newPswd.trim().length > 0) {
                this.setState({
                    newPswdEmpty: false
                });
                if(!Validate("password", this.state.newPswd)) {
                    this.setState({
                        newPswdRegex: true
                    });
                }
                else {
                    this.setState({
                        newPswdRegex: false
                    });
                }
            }
            if(this.state.currentPswd.trim().length <= 0) {
                this.setState({
                    currentPswdEmpty: true
                });
            }
            if(this.state.newPswd.trim().length <= 0) {
                this.setState({
                    newPswdEmpty: true
                });
            }
        }

    };
    componentDidMount() {
        document.styleSheets[1].disabled = true;
        this.loadCss();
        this.getCurrentMonthYear();
        this.getScroll();
    }
    componentWillUnmount() {
        document.styleSheets[1].disabled = false;
        var disbale1 = "partner-layout.css";
        var disbale2 = "partner-retina.css";
        var disbale3 = "partner-theme.css";
        var disbale4 = "partner-datepicker.css";
        Object.values(document.styleSheets).forEach(sheet => {
            let sheetLink = sheet.href;
            if(sheetLink !== null) {
                let urlLastName = sheetLink.split("/").pop();
                let sheetName = urlLastName.split("?");

                if(disbale1.indexOf(sheetName[0]) > -1) sheet.disabled = true;
                if(disbale2.indexOf(sheetName[0]) > -1) sheet.disabled = true;
                if(disbale3.indexOf(sheetName[0]) > -1) sheet.disabled = true;
                if(disbale4.indexOf(sheetName[0]) > -1) sheet.disabled = true;
            }

        });

    }
    getScroll = () => {

        var scroll_top = "<div class='scroll_top'><img border='0' alt='Top' src='https://www.idrivecompute.com/source/images/compute-arrow.png'></div>";
        $('body').append(scroll_top);
        $(window).resize(function () {
            'use strict';
            $.scroll_img();

        });
        $(window).scroll(function () {
            'use strict';

            $.scroll_img();
        });
        $.scroll_img = function () {
            var distanceTop = $('footer').offset().top - $(window).height();
            if($(window).scrollTop() < distanceTop && $(window).scrollTop() > 50) {
                $('.scroll_top').addClass('fixed');
            } else {
                $('.scroll_top').removeClass('fixed');
            }
        };
        $(document).on('click', '.scroll_top', function () {
            $('html, body').animate({
                scrollTop: 0
            }, 'slow', function () {
                $('.scroll_top').show().fadeOut(500);
            });
        });
    };
    changePassword = () => {
        if(this.state.currentPswd.length <= 0) {
            this.setState({
                currentPswdEmpty: true
            });
            this.currentPasswordFocus.current.focus();
        }
        else if(this.state.newPswd.length <= 0) {
            this.setState({
                newPswdEmpty: true
            });
            this.newPasswordFocus.current.focus();
        }
        else if(!Validate("password", this.state.newPswd)) {
            this.setState({
                newPswdEmpty: false,
                newPswdRegex: true
            });
            this.newPasswordFocus.current.focus();
        }
        else if(this.state.newPswd !== this.state.confirmPswd) {
            this.setState({
                confirmPswdError: true
            });
            this.confirmPasswordFocus.current.focus();
        }
        else {
            const data = {
                curpswd: this.state.currentPswd,
                newpswd: this.state.newPswd

            };
            this.setState({
                isAction: true
            });
            axiosInstance.post(API_HOST + '/bounty-partner/profile', data, axiosRequestWithAuth)
                .then(resp => {
                    resp = resp.data;
                    if(resp === "UPDATE_SUCCESS") {
                        this.setState({
                            isAction: false,
                            isPasswordEnable: false,
                            message: "Password has been updated"
                        });
                    }
                    else if(resp === "UPDATE_FAILED") {
                        this.setState({
                            isAction: false,
                            currentPswdError: true
                        });
                    } else if(resp === "SESSION_FAILED") {
                        this.setState({
                            isAction: false,
                            isPasswordEnable: false,
                            message: "Session failed, re-login"
                        });
                    }

                })
                .catch(error => {
                    this.setState({
                        isAction: false,
                        isPasswordEnable: false,
                        message: "Error while updating password, try again!"
                    });
                });
        }
    };
    resetReport = () => {
        this.setState({
            isAction: true
        });
        this.setState({
            currentMonth: this.state.resetMonth,
            currentYear: this.state.resetYear
        });
        let promoName = this.state.getDiscId;
        let month = this.state.resetMonth < 10 ? '0' + this.state.resetMonth : this.state.resetMonth;
        axiosInstance.get(API_HOST + '/bounty-partner/list?discId=' + promoName + '&month=' + month + '&year=' + this.state.resetYear, axiosRequestWithAuth).then(resp => {
            let res = resp.data;
            let user = [];
            let total = res.length;
            let isPartnerAvailable = false;
            for(let i = 0; i < res.length; i++) {
                let d = new Date(res[i].createdOn);
                let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',' + d.getFullYear() + ' ' + d.toLocaleString([], {
                    hour: '2-digit',
                    minute: '2-digit'
                });
                let taggedVal = '';
                let taggedUser = res[i].taggedUser;
                if(taggedUser !== undefined && taggedUser !== null) {
                    isPartnerAvailable = true;
                    taggedVal = taggedUser.value;
                }

                user.push({
                    name: res[i].firstName + " " + res[i].lastName,
                    email: res[i].email,
                    date: createdDate,
                    plan: res[i].discountId.type,
                    status: res[i].emailVerify != 1 ? "Inactive" : res[i].status === 'Y' ? 'Active' : 'Cancelled',
                    taggedVal: taggedVal
                });

            }

            user.sort(function (a, b) {
                if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                return 0;
            });
            this.setState({
                totalUsers: total,
                userList: user,
                showLoader: false,
                isAction: false,
                isPartnerAvailable: isPartnerAvailable
            });
        })
            .catch(error => {
                this.setState({
                    showLoader: false,
                    isAction: false,
                    message: "Error while fetching details"
                });
            });

    };
    getReport = (param) => {
        this.setState({
            isAction: true
        });

        let promoName = this.state.getDiscId;
        let month = this.state.currentMonth < 10 ? '0' + this.state.currentMonth : this.state.currentMonth;
        axiosInstance.get(API_HOST + '/bounty-partner/list?discId=' + promoName + '&month=' + month + '&year=' + this.state.currentYear, axiosRequestWithAuth).then(resp => {
            let res = resp.data;
            let user = [];
            let total = res.length;
            let isPartnerAvailable = false;
            for(let i = 0; i < res.length; i++) {
                let d = new Date(res[i].createdOn);
                let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',' + d.getFullYear() + ' ' + d.toLocaleString([], {
                    hour: '2-digit',
                    minute: '2-digit'
                });
                let taggedVal = '';
                let taggedUser = res[i].taggedUser;
                if(taggedUser !== undefined && taggedUser !== null) {
                    taggedVal = taggedUser.value;
                    isPartnerAvailable = true;
                }
                user.push({
                    name: res[i].firstName + " " + res[i].lastName,
                    email: res[i].email,
                    date: createdDate,
                    plan: res[i].discountId.type,
                    status: res[i].emailVerify != 1 ? "Inactive" : res[i].status === 'Y' ? 'Active' : 'Cancelled',
                    taggedVal: taggedVal
                });

            }

            user.sort(function (a, b) {
                if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                return 0;
            });
            this.setState({
                totalUsers: total,
                userList: user,
                showLoader: false,
                isAction: false,
                isPartnerAvailable: isPartnerAvailable
            });
        })
            .catch(error => {
                this.setState({
                    showLoader: false,
                    isAction: false,
                    message: "Error while fetching details"
                });
            });
    };
    getPartnerDiscountTag(tagName) {
        axiosInstance.get(API_HOST + '/bounty-partner/tag/' + tagName, axiosRequestWithAuth).then(resp => {
            if(resp && resp.data && resp.data.token) {
                let promoUrl = "https://www.idrivecompute.com?tag=";
                promoUrl = promoUrl + resp.data.token;
                this.setState({ promoUrl: promoUrl });
            }
        });
    }
    getCompleteReport = () => {
        this.setState({
            isAction: true
        });
        let promoName = this.state.getDiscId;
        axiosInstance.get(API_HOST + '/bounty-partner/list?discId=' + promoName, axiosRequestWithAuth).then(resp => {
            let res = resp.data;
            let user = [];
            let total = res.length;
            let isPartnerAvailable = false;
            for(let i = 0; i < res.length; i++) {
                let d = new Date(res[i].createdOn);
                let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',' + d.getFullYear() + ' ' + d.toLocaleString([], {
                    hour: '2-digit',
                    minute: '2-digit'
                });
                let taggedVal = '';
                let taggedUser = res[i].taggedUser;
                if(taggedUser !== undefined && taggedUser !== null) {
                    taggedVal = taggedUser.value;
                    isPartnerAvailable = true;
                }
                user.push({
                    name: res[i].firstName + " " + res[i].lastName,
                    email: res[i].email,
                    date: createdDate,
                    plan: res[i].discountId.type,
                    status: res[i].emailVerify != 1 ? "Inactive" : res[i].status === 'Y' ? 'Active' : 'Cancelled',
                    taggedVal: taggedVal
                });

            }
            user.sort(function (a, b) {
                if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                return 0;
            });
            this.setState({
                totalUsers: total,
                userList: user,
                showLoader: false,
                isAction: false,
                isPartnerAvailable: isPartnerAvailable
            });
        })
            .catch(error => {
                this.setState({
                    showLoader: false,
                    isAction: false,
                    message: "Error while fetching details",
                    msgType: "error"
                });
            });
    };
    showCurPswd = (param) => {
        if(param === "current") {
            this.setState({
                getcurpswd: !this.state.getcurpswd
            });
        }
        else if(param === "new") {
            this.setState({
                getnewpswd: !this.state.getnewpswd
            });
        }
    };

    handleInputs = (event) => {

        let name = event.target.name;
        let val = event.target.value;

        this.setState({
            [name]: val
        });
        if(name === "confirmPswd") {

            this.setState({
                confirmPswdError: false
            });

        }
        if(name === "currentPswd") {

            if(val.length > 0) {
                this.setState({
                    currentPswdEmpty: false,
                    currentPswdError: false
                });
            }
            else {
                this.setState({
                    currentPswdEmpty: true,
                    currentPswdError: false
                });
            }
        }
        if(name === "newPswd") {
            this.setState({
                newPswdEmpty: false,
                newPswdError: false,
                newPswdRegex: false
            });
            if(val.length > 0) {
                var upCasePatt = new RegExp("[A-Z]");
                if(upCasePatt.test(val)) {
                    $('#upperCaseLi').addClass("success");
                } else {
                    $('#upperCaseLi').removeClass("success");
                }
                var lowCasePatt = new RegExp("[a-z]");
                if(lowCasePatt.test(val)) {
                    $('#lowerCaseLi').addClass("success");
                } else {
                    $('#lowerCaseLi').removeClass("success");
                }
                var numericPatt = new RegExp("[0-9]");
                if(numericPatt.test(val)) {
                    $('#numericLi').addClass("success");
                } else {
                    $('#numericLi').removeClass("success");
                }
                var specCharPat = /[`!@#$%^&*()_+\-={};':"|,.<>\/?~]/;
                if(specCharPat.test(val)) {
                    $('#specCharLi').addClass("success");
                } else {
                    $('#specCharLi').removeClass("success");
                }
                if(val.length >= 8) {
                    $('#eightCharLi').addClass("success");
                } else {
                    $('#eightCharLi').removeClass("success");
                }
            }
            else {
                this.setState({
                    newPswdEmpty: true,
                    newPswdError: false,
                    newPswdRegex: false
                });
                $('#upperCaseLi').removeClass("success");
                $('#lowerCaseLi').removeClass("success");
                $('#numericLi').removeClass("success");
                $('#specCharLi').removeClass("success");
                $('#eightCharLi').removeClass("success");
            }

        }
    };

    getCurrentMonthYear = () => {
        let promoId = this.state.trackId;
        this.getPartnerDiscountTag(promoId);
        let date = new Date();
        let year = date.getFullYear();
        let yearList = [];
        for(let i = 0; i < 10; i++) {
            yearList.push(year - i);
        }
        let promoBaseUrl = "https://www.idrivecompute.com/app/promo/";
        Axios.get(API_HOST + "/bounty-partner/gettype/" + promoId).then(resp => {
            let result = resp.data;
            if(result.codeType == "baremetal") {
                promoBaseUrl += "bare/";
            }
            this.setState({
                yearData: yearList,
                promoUrl: promoBaseUrl + promoId,
                getDiscId: result.id
            }, () => { this.getReport("get"); });

        }).
            catch(resp => {
                console.log(resp);
            });

    };

    logout = () => {

        SessionService.removeCookie("_partner_cookie");
        SessionService.removeCookie("partner_username");
        window.location.href = API_HOST + "/bounty-partner/logout";
    };

    enableChangePassword = () => {

        this.setState({
            isPasswordEnable: true,
            currentPswd: "",
            newPswd: "",
            confirmPswd: "",
            currentPswdEmpty: false,
            newPswdEmpty: false,
            confirmPswdError: false,
            currentPswdError: false,
            newPswdRegex: false,
            newPswdError: false,
        });
        $('#upperCaseLi').removeClass("success");
        $('#lowerCaseLi').removeClass("success");
        $('#numericLi').removeClass("success");
        $('#specCharLi').removeClass("success");
        $('#eightCharLi').removeClass("success");
        setTimeout(() => {
            this.currentPasswordFocus.current.focus();
        }, 100);
    };

    loadCss = () => {
        document.title = "IDrive® Compute | IDrive Homepage";
        const link = document.createElement("link");
        link.href = "https://www.idrivecompute.com/partner/include/css/partner-layout.css?v=1.0";
        link.rel = "stylesheet";
        link.type = "text/css";
        document.head.appendChild(link);

        const link1 = document.createElement("link");
        link1.href = "https://www.idrivecompute.com/partner/include/css/partner-retina.css?v=1.0";
        link1.rel = "stylesheet";
        link1.type = "text/css";
        document.head.appendChild(link1);

        const link2 = document.createElement("link");
        link2.href = "https://www.idrivecompute.com/partner/include/css/partner-theme.css?v=1.0";
        link2.rel = "stylesheet";
        link2.type = "text/css";
        document.head.appendChild(link2);

        const link3 = document.createElement("link");
        link3.href = "https://www.idrivecompute.com/partner/include/css/partner-datepicker.css?v=1.0";
        link3.rel = "stylesheet";
        link3.type = "text/css";
        document.head.appendChild(link3);

        setTimeout(() => {
            this.setState({
                showLoader: false
            });
        }, 1000);
    };
    headerSortClick = (event) => {
        $('.sort_icon').removeClass('active');
        $(event.currentTarget).find('.sort_icon').addClass('active');
        $(event.currentTarget).find('.sort_icon').toggleClass('toggle_sort');
    };

    setSortable = (param) => {
        let items = [...this.state.userList];
        if(param === "username") {
            if(this.state.nameToggle) {
                items.sort(function (a, b) {
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return 1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return -1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                    return 0;
                });
            }
            this.setState({
                nameToggle: !this.state.nameToggle,
                userList: items
            });
        }
        else if(param === "email") {
            if(this.state.emailToggle) {
                items.sort(function (a, b) {
                    if(a.email.toLowerCase() < b.email.toLowerCase()) { return 1; }
                    if(a.email.toLowerCase() > b.email.toLowerCase()) { return -1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(a.email.toLowerCase() < b.email.toLowerCase()) { return -1; }
                    if(a.email.toLowerCase() > b.email.toLowerCase()) { return 1; }
                    return 0;
                });
            }
            this.setState({
                emailToggle: !this.state.emailToggle,
                userList: items
            });
        }
        else if(param === "date") {
            if(this.state.dateToggle) {
                items.sort(function (a, b) {
                    return new Date(a.date) - new Date(b.date);
                });
            }
            else {
                items.sort(function (a, b) {
                    return new Date(b.date) - new Date(a.date);
                });

            }
            this.setState({
                dateToggle: !this.state.dateToggle,
                userList: items
            });
        }
        else if(param === "plan") {
            if(this.state.planToggle) {
                items.sort(function (a, b) {
                    if(a.plan.toLowerCase() < b.plan.toLowerCase()) { return 1; }
                    if(a.plan.toLowerCase() > b.plan.toLowerCase()) { return -1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(a.plan.toLowerCase() < b.plan.toLowerCase()) { return -1; }
                    if(a.plan.toLowerCase() > b.plan.toLowerCase()) { return 1; }
                    return 0;
                });
            }
            this.setState({
                planToggle: !this.state.planToggle,
                userList: items
            });
        }
        else if(param === "status") {
            if(this.state.statusToggle) {
                items.sort(function (a, b) {
                    if(a.status.toLowerCase() < b.status.toLowerCase()) { return 1; }
                    if(a.status.toLowerCase() > b.status.toLowerCase()) { return -1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(a.status.toLowerCase() < b.status.toLowerCase()) { return -1; }
                    if(a.status.toLowerCase() > b.status.toLowerCase()) { return 1; }
                    return 0;
                });
            }
            this.setState({
                statusToggle: !this.state.statusToggle,
                userList: items
            });
        }
    };

    render() {
        if(this.state.showLoader) {
            return (
                <div class="full_page_loader" style={ { display: this.state.showLoader ? "block" : "none" } }><div class="loader_icon"></div></div>
            );
        }
        return (
            <body>
                { this.state.message ?
                    <div class={ "common_user_message " + this.state.msgType }>
                        <div class="message_content">
                            <p>{ this.state.message }</p>
                            <span class="close_icon" dataToggle="tooltip" title="" dataOriginalTitle="Close" onClick={ () => this.setState({ message: "" }) }></span>
                        </div>
                    </div>
                    : null
                }

                <div class="full_page_loader" style={ { display: this.state.isAction ? "block" : "none" } }><div class="loader_icon"></div></div>
                <header class="header">
                    <div class="wrapper">
                        <div class="inner-wrap">
                            <div class="header-menu">
                                <ul>
                                    <li>Partner ID: { this.state.trackId } </li>
                                    <li>|<a class="edit_profile" href="javascript:;" onClick={ () => this.enableChangePassword() }> Change Password </a></li>
                                    <li class="logout"><a href="javascript:;" onClick={ () => { this.logout(); } }>Logout</a></li>
                                </ul>
                            </div>
                            <a class="logo" href="https://www.idrivecompute.com/index.html" target="_blank"></a>
                        </div>
                    </div>

                </header>
                <div class="master_wrapper" style={ { display: this.state.isPasswordEnable ? "block" : "none" } }>
                    <div class="shadow_container"></div>
                    <div class="popup_wrapper">
                        <div class="first_pos_container">
                            <div class="sec_pos_container">
                                <div id="cancelWithReason" class="popup_container popup_deactivate main_acc_cancel popLeft" style={ { display: this.state.isPasswordEnable ? "block" : "none" } }>
                                    <form>
                                        <section class="popup_header">
                                            <h2 class="deactivate_title">Change Password</h2>
                                            <span class="popup_close_btn hide_popup" onClick={ () => { this.setState({ isPasswordEnable: false }); } }></span>
                                        </section>
                                        <section class="popup_content">
                                            <div class="deactivate_box">
                                                <p style={ { display: this.state.isPasswordEnable ? "block" : "none" } } id="cancelationWithReasonMessage" class="err_msg"></p>

                                                <div class="editPro">
                                                    <div class="row-span pass_hide" style={ { display: this.state.isPasswordEnable ? "block" : "none" } }>
                                                        <label>Current Password:</label>
                                                        <div className="pwd_field_wrap">
                                                            <input type={ this.state.getcurpswd ? "text" : "password" } maxLength="20" value={ this.state.currentPswd } name="currentPswd" ref={ this.currentPasswordFocus } id="curpassword" class="input" onChange={ this.handleInputs } onKeyUp={ this.handleOTPKeyUp } />
                                                            <span className={ this.state.getcurpswd ? "pwd_field_eyeIcon show_pwd" : "pwd_field_eyeIcon" } data-tip data-for="popupcurntpassword" onClick={ () => this.showCurPswd("current") }></span>
                                                            <ReactToolTip id="popupcurntpassword" effect="solid">
                                                                { this.state.getcurpswd ? "Hide" : "Show" }
                                                            </ReactToolTip>
                                                        </div>

                                                        { this.state.currentPswdEmpty ? <span className="error_msg" style={ { display: 'block' } }>Current password cannot be blank</span> : "" }
                                                        { this.state.currentPswdError ? <span className="error_msg" style={ { display: 'block' } }>Current password is not correct </span> : "" }
                                                    </div>
                                                    <div class="row-span pass_hide" style={ { display: this.state.isPasswordEnable ? "block" : "none" } }>
                                                        <label>New Password:</label>
                                                        <div className="pwd_field_wrap">
                                                            <input type={ this.state.getnewpswd ? "text" : "password" } maxLength="20" ref={ this.newPasswordFocus } value={ this.state.newPswd } name="newPswd" id="curpassword" class="input" onChange={ this.handleInputs } onFocus={ () => this.inputFocus("newPswd") } onClick={ () => this.inputFocus("newPswd") } onKeyUp={ this.handleOTPKeyUp } />
                                                            <div className="id-tooltip id-tooltip-topright new-pass">
                                                                <p className="id-tooltip-note">Use atleast:</p>
                                                                <ul>
                                                                    <li id="upperCaseLi">1 uppercase character</li>
                                                                    <li id="lowerCaseLi">1 lowercase character</li>
                                                                    <li id="numericLi">1 numerical digit</li>
                                                                    <li id="specCharLi">1 special character</li>
                                                                    <li id="eightCharLi">Min 8 characters</li>
                                                                </ul>
                                                            </div>
                                                            <span className={ this.state.getnewpswd ? "pwd_field_eyeIcon show_pwd" : "pwd_field_eyeIcon" } data-tip data-for="popupnewpassword" onClick={ () => this.showCurPswd("new") }></span>
                                                            <ReactToolTip id="popupnewpassword" effect="solid">
                                                                { this.state.getnewpswd ? "Hide" : "Show" }
                                                            </ReactToolTip>
                                                        </div>
                                                        { this.state.newPswdEmpty ? <span className="error_msg" style={ { display: 'block' } }>New password can not be blank</span> : "" }
                                                        { this.state.newPswdRegex ? <span className="error_msg" style={ { display: 'block' } }>Password is invalid </span> : "" }
                                                        { this.state.newPswdError ? <span className="error_msg" style={ { display: 'block' } }>Password is invalid </span> : "" }
                                                    </div>
                                                    <div class="row-span pass_hide" style={ { display: this.state.isPasswordEnable ? "block" : "none" } }>
                                                        <label>Confirm Password:</label>
                                                        <input type="password" name="confirmPswd" maxLength="20" ref={ this.confirmPasswordFocus } value={ this.state.confirmPswd } id="cnfpassword" class="input" onChange={ this.handleInputs } onFocus={ () => this.inputFocus("confirmPswd") } onClick={ () => this.inputFocus("confirmPswd") } onKeyUp={ this.handleOTPKeyUp } />

                                                        { this.state.confirmPswdError ? <span className="error_msg" style={ { display: 'block' } }>New password and Confirm password does not match</span> : "" }

                                                    </div>
                                                    <div class="row-span pass_hide" style={ { display: this.state.isPasswordEnable ? "block" : "none" } }>
                                                        <input type="button" class="send submit" value="Save" onClick={ () => this.changePassword() } />
                                                        <input type="button" class="cancl" value="Cancel" onClick={ () => { this.setState({ isPasswordEnable: false }); } } />

                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <section class="wrapper ">
                    <div class="dashboard-wrap">
                        <div class="menu-icon">menu</div>
                        <div class="dashboard-title">
                            <h1>Promotional Tracking Dashboard</h1>
                        </div>
                        <div class="reseller-sort">
                            <span id="errorMes" class="red" style={ { display: "none" } }>Select a year</span>
                            <div className="filter_blk">
                                <div>
                                    <label class="reseller-dropdown">
                                        <select class="reseller-select" value={ this.state.currentMonth } size="1" name="currentMonth" id="month" onChange={ this.handleInputs }>
                                            <option value="1" >January</option>
                                            <option value="2" >February</option>
                                            <option value="3" >March</option>
                                            <option value="4" >April</option>
                                            <option value="5" >May</option>
                                            <option value="6" >June</option>
                                            <option value="7" >July</option>
                                            <option value="8" >August</option>
                                            <option value="9" >September</option>
                                            <option value="10" >October</option>
                                            <option value="11" >November</option>
                                            <option value="12" >December</option>
                                        </select>
                                    </label>
                                </div>
                                <div>
                                    <label class="reseller-dropdown">
                                        <select class="reseller-select year" value={ this.state.currentYear } onChange={ this.handleInputs } size="1" name="currentYear" id="year">
                                            { this.state.yearData.map((year) =>
                                                <option value={ year } >{ year }</option>
                                            ) }
                                        </select>
                                    </label>
                                </div>
                            </div>
                            <input type="button" class="gent_btn" id="view" value="View Report" onClick={ () => this.getReport("get") }></input>
                            <input type="button" name="reset" value="Reset" class="reset_btn" onClick={ () => this.resetReport() }></input>

                            <div class="linkhead"><input type="button" id="viewAll" class="gent_btn all" value="View Complete Report" onClick={ () => this.getCompleteReport() } /></div>
                            <span id="errorMes" class="red" style={ { marginLeft: "20px", marginTop: "6px", display: "none", float: "left" } }></span>
                        </div>
                        <div class="clear"></div>
                        <section class="rgt-wrap">
                            <div class="lft-link-wrap">
                            </div>
                            <div class="inside-wrap">
                                <div class="con-satatic"> <a name="sales-report" id="sales-report"> </a>
                                    <div class="con-title">
                                        <div class="common_msg error_msg">
                                            <p>Error mesaage display here.</p>
                                            <a class="close_info"><img width="16" height="16" title="Close" alt="close" src="include/images/close.png" /></a>
                                        </div>
                                        <div class="brd-box">
                                            <div class="sales-table">
                                                <div class="sales-tableHead">
                                                    <h3>Promotional tracking URL: <a href={ this.state.promoUrl } target="_blank">{ this.state.promoUrl }</a></h3>
                                                    <div class="reports-view">
                                                        <ul>
                                                            <li class="totalUsers"> Total Users : <span>{ this.state.totalUsers }</span> </li>
                                                            <li class="paidUsers" style={ { display: "none" } }> Paid Users : <span>133</span> </li>
                                                            <li class="freeUsers" style={ { display: "none" } }> Free Users : <span>112</span> </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div class="clear"></div>
                                                <div class="scroll-wrap">
                                                    <div class="scroll-box">
                                                        <table class="report-table" cellSpacing="0">
                                                            <thead class="table-header">
                                                                <tr>
                                                                    <th class="sales-uname" onClick={ (event) => { this.headerSortClick(event); this.setSortable("username"); } }>Name<span class="sort_icon active"></span></th>
                                                                    <th class="sales-email" onClick={ (event) => { this.headerSortClick(event); this.setSortable("email"); } }>Email<span class="sort_icon"></span></th>
                                                                    <th class="sales-date" onClick={ (event) => { this.headerSortClick(event); this.setSortable("date"); } }>Creation date<span class="sort_icon  "></span></th>
                                                                    <th class="sales-earn" style={ { display: "none" } } onClick={ (event) => { this.headerSortClick(event); this.setSortable("plan"); } }>Plan Type<span class="sort_icon "></span> </th>
                                                                    <th class="sales-date" style={ { display: this.state.isPartnerAvailable ? '' : 'none' } } >Extra</th>

                                                                    <th class="sales-status" onClick={ (event) => { this.headerSortClick(event); this.setSortable("status"); } }>Status<span class="sort_icon "></span></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody class="table-inner-wrap">
                                                                { this.state.userList.length <= 0 ?
                                                                    <tr class="no-dataFound">
                                                                        <td colspan="5"><i></i><p>No records found</p></td></tr>
                                                                    :
                                                                    this.state.userList.map((user, index) =>
                                                                        <tr key={ index }>
                                                                            <td class="sales-uname">
                                                                                <div class="name-blk">
                                                                                    <div class="name_icon"><span>{ user.name.charAt(0).toUpperCase() }</span></div>
                                                                                    <p ><span data-tip data-for={ user.name + user.email }>{ user.name }</span></p>
                                                                                    <ReactToolTip id={ user.name + user.email } effect="solid">
                                                                                        { user.name }
                                                                                    </ReactToolTip>
                                                                                </div>
                                                                            </td>
                                                                            <td class="sales-email"><span data-tip data-for={ user.email }>{ user.email }</span>
                                                                                <ReactToolTip id={ user.email } effect="solid">
                                                                                    { user.email }
                                                                                </ReactToolTip>
                                                                            </td>

                                                                            <td class="sales-date"><p>{ user.date }</p></td>
                                                                            <td class="sales-earn" style={ { display: "none" } }>{ user.plan } </td>
                                                                            <td style={ { display: this.state.isPartnerAvailable ? '' : 'none' } }>{ user.taggedVal }</td>
                                                                            <td class={ user.status === "Cancelled" ? "sales-status cancelled" : "sales-status" }>{ user.status }</td>
                                                                        </tr>
                                                                    )
                                                                }


                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </section>
                        <div class="scroll_top" style={ { display: "none" } }><img border="0" alt="Top" src="https://www.idrivecompute.com/source/images/compute-arrow.png" /></div>
                        <footer>
                            <div class="wrapper">
                                <p>&copy;IDrive Inc.</p>
                            </div>
                        </footer>
                    </div>

                </section>

                <div class="loading_wrapper"></div>

            </body>
        );
    }
}

export default Partnerindex;